/**
 * Phase 14.1 — Asset-Manifest für die Marketing-Page.
 *
 * Wenn ein Pfad gesetzt ist, lädt {@link MarketingImage} das Bild aus
 * {@code public/marketing/}. Ist der Wert {@code null}, fällt die Komponente
 * auf den jeweiligen SVG-Mockup zurück (siehe
 * {@code src/components/marketing/mockups/}).
 *
 * Aktuell sind keine Screenshots vorhanden — alle Slots stehen auf {@code null}
 * und werden als Mockup gerendert. Sobald ein Screenshot in
 * {@code public/marketing/} liegt, hier den Pfad eintragen.
 */
export type MarketingImageId =
  | 'heroMap'
  | 'missionDetail'
  | 'arrest'
  | 'crossOrg'
  | 'vehicleConfig'
  | 'stationOverview';

export const MARKETING_IMAGES: Record<MarketingImageId, string | null> = {
  heroMap: null,
  missionDetail: null,
  arrest: null,
  crossOrg: null,
  vehicleConfig: null,
  stationOverview: null,
};
